import { all } from 'redux-saga/effects';

import libraryCategorySaga from './category';
import libraryDiscountSaga from './discount';
import libraryGratuitySaga from './gratuity';
import libraryTaxSaga from './tax';
import libraryItemSaga from './item';
import librarySalesTypeSaga from './salesType';
import libraryModifierSaga from './modifier';
import libraryBrandSaga from './brand';
import libraryBundlePackageSaga from './bundlePackage';

export default function* librarySaga() {
  yield all([
    libraryCategorySaga(),
    libraryDiscountSaga(),
    libraryGratuitySaga(),
    libraryTaxSaga(),
    libraryModifierSaga(),
    libraryItemSaga(),
    librarySalesTypeSaga(),
    libraryBrandSaga(),
    libraryBundlePackageSaga(),
  ]);
}
